import React, { Component } from 'react'
import urlFor, { QueryParams } from 'shared/tools/url-helper'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import Spacer from 'client/shared/blocks/spacer'
import LayoutInfo from 'client/bookmate/blocks/layout-info'
import ExpandableText from 'client/shared/blocks/expandable-text'

import { prepareUserSiteLink } from 'client/shared/helpers/url-helpers'

import SVGInline from 'react-svg-inline'
import TwitterIcon from 'client/shared/icons/twitter2.svg'

import { UserAvatar } from 'client/shared/blocks/user-avatar'
import Linka from 'client/shared/blocks/linka'
import FollowButtonBox from 'client/bookmate/boxes/follow-button-box'

import UsersList from 'client/bookmate/blocks/users-list'
import { Heading } from 'client/shared/blocks/heading'

import { CurrentUserData } from 'client/shared/types/current-user'
import { UserShort } from 'client/shared/types/user'
import './user-info.styl'

type Props = {
  user: CurrentUserData
  followers: UserShort[]
  country?: string
  query?: QueryParams
} & DecoratorProps

class _UserInfo extends Component<Props> {
  render() {
    return (
      <LayoutInfo
        lead={() => this.renderLead()}
        header={this.renderHeader}
        body={this.renderBody}
        aside={this.renderAside}
      />
    )
  }

  renderLead = () => {
    return (
      <div className="user-info__lead">
        <UserAvatar
          user={this.props.user}
          size={{
            desktopLarge: 176,
            desktopMedium: 176,
            desktop: 124,
            tablet: 124,
            mobile: 88,
          }}
        />
      </div>
    )
  }

  renderHeader = () => {
    const {
      isMobileSize,
      isOneColumnSize,
      user: { login, name },
      query,
    } = this.props

    return (
      <div>
        <div className="user-info__name-and-login">
          <Linka path={urlFor.user(login, query)} className="user-info__login">
            @{login}
          </Linka>
          <Spacer size={8} />
          <Heading kind="kazimir" looksLike={isOneColumnSize() ? 3 : 1}>
            {name || login}
          </Heading>
          <Spacer />
        </div>
        {!isMobileSize() && this.renderCTA()}
      </div>
    )
  }

  renderBody = () => {
    const {
      isMobileSize,
      isOneColumnSize,
      user: { site, about, twitter },
    } = this.props

    return (
      <div>
        <Spacer />
        {isMobileSize() && this.renderCTA()}
        {about && <ExpandableText text={about} maxHeight={144} />}
        <Spacer />
        <div>
          {site && (
            <span className="user-info__site">
              <a href={prepareUserSiteLink(site)}>{site}</a>
            </span>
          )}
          {twitter && (
            <Linka path={twitter} className="user-info__social-link">
              <SVGInline
                className="user-info__social-link-icon"
                svg={TwitterIcon}
              />
            </Linka>
          )}
        </div>
        {isOneColumnSize() && (
          <div>
            <Spacer size={24} />
            {this.renderFollowersBlock()}
          </div>
        )}
      </div>
    )
  }

  renderAside = () => {
    return <div>{this.renderFollowersBlock()}</div>
  }

  renderCTA() {
    const {
      user,
      user: { myself, following },
    } = this.props

    if (myself) return null

    return (
      <div>
        <FollowButtonBox user={user} following={following} width="160px" />
        <Spacer />
      </div>
    )
  }

  renderFollowersBlock() {
    const {
      user: { followers_count, myself },
      followers,
      query,
    } = this.props

    if (myself || !followers.length) {
      return null
    } else {
      return (
        <div>
          <UsersList
            query={query}
            isUserInfoPage
            users={followers}
            usersCount={followers_count as number}
            message="profile.common_followers"
          />
          <Spacer />
        </div>
      )
    }
  }
}

export const UserInfo = uiBox(_UserInfo)
